import classNames from "classnames/bind";
import styles from "./DetailInfo.module.css";
import image from "../../../../../../assets/images/Car-demo.png";
import lisence from "../../../../../../assets/images/lisence.png";
const cx = classNames.bind(styles);

const DetailInfo = ({info}) => {
  const infoObject = [
    {
      title: "Camera",
      content: "Như Anh 2 - Camera 2",
      type: "string",
    },
    {
      title: "Thời gian",
      content: "16:30:30 - 17/02/2023",
      type: "string",
    },
    {
      title: "Loại biển:",
      content: "Xe hoạt động kinh doanh vận tải",
      type: "string",
    },
    {
      title: "Hãng xe",
      content: "Hyundai",
      type: "string",
    },
    {
      title: "Biển số",
      content: "30A-638.32",
      type: "string",
    },
    {
      title: "Ảnh biển số",
      content: lisence,
      type: "img",
    },
  ];
  return (
    <div className={cx("container")}>
      <h3 className={cx("header")}>Thông tin chi tiết</h3>
      <div className={cx("body")}>
        <div className={cx("image-object")}>
          <img
            alt="no-img"

            src={`${process.env.REACT_APP_BASE_URL}event${info.camera_image}`}

            style={{ height: "100%", width: "100%" }}
          />
        </div>
        <div className={cx("info-object")}>
          <div className={cx("row-info")}>
            <label className={cx("label-info")}>Camera</label>
            <div className={cx("content-info")}>
              Như anh - Camera số 2
            </div>
          </div>
          <div className={cx("row-info")}>
            <label className={cx("label-info")}>Thời gian:</label>
            <div className={cx("content-info")}>
             {info.time}
            </div>
          </div>
          <div className={cx("row-info")}>
            <label className={cx("label-info")}>Loại biển:</label>
            <div className={cx("content-info")}>
            Xe hoạt động kinh doanh vận tải
            </div>
          </div>
          <div className={cx("row-info")}>
            <label className={cx("label-info")}>Hãng xe:</label>
            <div className={cx("content-info")}>
            Hyundai
            </div>
          </div>
          <div className={cx("row-info")}>
            <label className={cx("label-info")}>Biển số</label>
            <div className={cx("content-info")}>
                {info.license}
            </div>
          </div>
          <div className={cx("row-info")}>
            <label className={cx("label-info")}>Ảnh biển số:</label>
            <div className={cx("content-info")}>
              <img alt="plate" src={`${process.env.REACT_APP_BASE_URL}event${info.plate_image}`} />
            </div>
          </div>
         
        </div>
      </div>
    </div>
  );
};

export default DetailInfo;
